export const filtersData = [
  {
    title: 'People',
    dbTitle: 'people',
    filters: [
      {
        name: 'Closeup'
      },
      {
        name: 'Single person'
      },
      {
        name: 'Couple'
      },
      {
        name: 'Collaboration'
      },
      {
        name: 'Other'
      }
    ]
  },
  {
    title: 'Motive',
    dbTitle: 'motive',
    filters: [
      {
        name: 'Technology'
      },
      {
        name: 'Corporate'
      },
      {
        name: 'Consumer'
      },
      {
        name: 'Artistic'
      },
      {
        name: 'Industrial'
      },
      {
        name: 'Other'
      }
    ]
  },
  {
    title: 'Background',
    dbTitle: 'background',
    filters: [
      {
        name: 'Black'
      },
      {
        name: 'Dark'
      },
      {
        name: 'Bright'
      },
      {
        name: 'Pastel'
      },
      {
        name: 'Vibrant'
      }
    ]
  },
  {
    title: 'Orientation',
    dbTitle: 'orientation',
    filters: [
      {
        name: '16:9'
      },
      {
        name: '1:1 Square'
      },
      {
        name: 'Panorama'
      },
      {
        name: 'Portrait'
      },
      {
        name: 'Round'
      }
    ]
  },
  {
    title: 'Style',
    dbTitle: 'style',
    filters: [
      {
        name: 'Classic'
      },
      {
        name: 'Creative'
      },
      {
        name: 'Organic'
      },
      {
        name: 'Squared'
      }
    ]
  },
  {
    title: 'Color',
    dbTitle: 'color',
    filters: [
      {
        name: ''
      }
    ],
    colors: ['white', 'black', 'purple', 'blue', 'red', '#ec7600', 'green']
  }
]
